import { render, staticRenderFns } from "./VGridRow.vue?vue&type=template&id=384ae068&"
import script from "./VGridRow.vue?vue&type=script&lang=ts&"
export * from "./VGridRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports